

const SearchPopup = ({ animationClass, popupContentRef, searchResult, onTrackSelect }) => {
  return (
    <div className="search-popup">
      <div className={`popup-content animate__animated ${animationClass}`} ref={popupContentRef}>
        <div className="search-results">
          {searchResult.map((track) => (
            <button className="search-result" onClick={() => onTrackSelect(track)} key={track.id}>
              <div className="music-cover" style={{ backgroundImage: `url(${track.image})` }}></div>
              <div className="music-name ellipsis">{track.name || 'Unknown Song'}</div>
              <div className="music-artist">{track.artist || 'Unknown Artist'}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchPopup;
